var map = {
	"./algeria.png": "8066",
	"./america.png": "7f5e",
	"./angola.png": "6644",
	"./argentina.png": "8916",
	"./australia.png": "a331",
	"./austria.png": "0493",
	"./belgium.png": "51c7",
	"./brasil.png": "3d25",
	"./canada.png": "496c",
	"./chile.png": "0c93",
	"./china.png": "6377",
	"./colombia.png": "50303",
	"./congo.png": "b21a",
	"./denmark.png": "5dd1",
	"./ecuador.png": "7b06",
	"./egypt.png": "5744",
	"./ethiopia.png": "7013",
	"./fiji.png": "f627",
	"./finland.png": "bf60",
	"./france.png": "d3e3",
	"./germany.png": "5b65",
	"./india.png": "4047",
	"./indonesia.png": "e259",
	"./iran.png": "ff95",
	"./ireland.png": "4ddf",
	"./israel.png": "c59c",
	"./italy.png": "2127",
	"./japan.png": "b88b",
	"./kenya.png": "f6a9",
	"./korea.png": "5634",
	"./malaysia.png": "13cc",
	"./mexico.png": "7165",
	"./nederland.png": "8ce8",
	"./newzealand.png": "e9bb",
	"./norway.png": "96c9",
	"./pakistan.png": "cc18",
	"./papuanewguinea.png": "2939",
	"./paraguay.png": "c1dc",
	"./philippines.png": "60cf",
	"./poland.png": "b54e",
	"./russia.png": "4d64",
	"./saudiarabia.png": "ff40",
	"./shape_roulette_anime.gif": "9812",
	"./singapore.png": "3b5e",
	"./southafrica.png": "80b2",
	"./spain.png": "f115",
	"./sweden.png": "f191",
	"./switzerland.png": "b661",
	"./thailand.png": "83be",
	"./turkey.png": "99c4",
	"./uk.png": "e25f",
	"./venezuela.png": "2fd3",
	"./zimbabwe.png": "d163"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22f4";